import { render, staticRenderFns } from "./SyncConfigForm.vue?vue&type=template&id=3a1f8266&scoped=true"
import script from "./SyncConfigForm.vue?vue&type=script&lang=js"
export * from "./SyncConfigForm.vue?vue&type=script&lang=js"
import style0 from "./SyncConfigForm.vue?vue&type=style&index=0&id=3a1f8266&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f8266",
  null
  
)

export default component.exports